export enum Typing {
    Active = "active",
    Paused = "paused",
    Done = "done",
}
